<template>
    <!-- 自定义树形穿梭框组件、理论上左右均可选择是否为树形结构，目前固定为左侧树形、右侧无层级结构 -->
    <div class="tree-transfer">
        <!-- 穿梭框左侧 -->
        <div class="tree-transfer-left">
			<div class="title">请选择部门</div>
			<div class="opt"><el-checkbox v-model="checkedLeft" @change="handleCheckLeftAllChange">全选/全不选</el-checkbox></div>
			<div class="kTree">
				<el-tree
					v-if="dataLeft.length>0"
				    ref="treeLeft"
				    :data="dataLeft"
				    show-checkbox
				    node-key="id"
					check-strictly
					:default-checked-keys="checkedLeftData"
					@check-change="handleNodeCheckChangeLeft"
				    :props="{label:'department_name',value:'id'}">
				</el-tree>
			</div>
            <!-- 左侧采用element-ui的el-tree -->
        </div>
        <!-- 穿梭框中间按钮区域 -->
        <div class="tree-transfer-middle">
            <el-button circle type="primary" icon="el-icon-arrow-right" @click="add"></el-button>
        </div>
        <!-- 穿梭框右侧 -->
        <div class="tree-transfer-right">
            <!-- 右侧直接放置结果 -->
            <!-- 这里也采用tree结构，默认是对数据进行处理使得没有树形结构，也可以选择有树形结构 -->
			<div class="title">请选择人员</div>
			<div class="opt"><el-checkbox v-model="checkedRight" @change="handleCheckRightAllChange">全选/全不选</el-checkbox></div>
			<div class="kTree">
				<el-tree
					v-if="dataRight.length>0"
				    ref="treeRight"
				    :data="dataRight"
				    show-checkbox
				    node-key="value"
					check-strictly
					:default-checked-keys="checkedRightData"
					@check-change="handleNodeCheckChangeRight"
				    :props="{label:'label',value:'value'}">
				</el-tree>
			</div>
        </div>
    </div>
</template>

<script>
    export default{
        props: ['item'],
        data(){
            return{
                dataLeft:[],
                dataRight:[],
				checkedLeft:[],
				checkedLeftData:[],
				checkedRight:[],
				checkedRightData:[]
            }
        },
        mounted() {
			this.getContactIds()
        },
        methods:{
			//获取对接人
			getContactIds(){
				this.$api.get('/admin/users/user/getDepartmentTree',{customer_code:this.item.customer_code}).then(res => {
					if (res.code === 0) {
						this.dataLeft = res.data;//获取商务
						if(this.item.contact_ids && this.item.contact_ids.length >0){
							this.checkedLeftData = this.item.contact_ids_department
							this.add()
						}
					} else {
					  this.$message.error(res.msg);
					}
					this.loading = false
				})
			},
			handleCheckLeftAllChange(val) {
			  this.checkAllNodes(this.dataLeft, val);
			},
			//全选
			checkAllNodes(nodes, checked) {
				if(checked){
					let arr = []
					 nodes.forEach(node => {
						arr.push(node.id)
						// 如果节点有子节点，递归设置子节点的选中状态
						if (node.children && node.children.length > 0) {
						  node.children.forEach(nodechild => {
							arr.push(nodechild.id)
						  });
						}
					 });
					this.$refs.treeLeft.setCheckedKeys(arr);
					this.checkedLeft = arr
				}else{
					this.$refs.treeLeft.setCheckedKeys([])
					this.checkedLeft = []
				}
			},
			handleNodeCheckChangeLeft(node, checked) {
			  // 当某个节点的选中状态发生变化时，检查是否所有节点都被选中
			  const allNodes = this.getAllNodes(this.dataLeft);
			  const allChecked = allNodes.every(n => this.$refs.treeLeft.getCheckedKeys().includes(n.id));
			  this.checkedLeftData = this.$refs.treeLeft.getCheckedKeys()
			  // 更新全选按钮的状态
			  this.checkedLeft = allChecked;
			},
			getAllNodes(nodes) {
			  let allNodes = [];
			  nodes.forEach(node => {
				allNodes.push(node);
				if (node.children && node.children.length > 0) {
				  allNodes = allNodes.concat(this.getAllNodes(node.children));
				}
			  });
			  return allNodes;
			},
            add(){
					this.$api.post('/admin/users/user/getuserbydepartment',{department_id:this.checkedLeftData,customer_code:this.item.customer_code}).then(res => {
						if (res.code === 0) {
							this.dataRight = res.data
							var ids = []
							if(this.$refs.treeRight){
								let tree_checked = this.$refs.treeRight.getCheckedNodes()
								
								ids = tree_checked.map(item => item.value)
							}else{
								ids = this.item.contact_ids
							}	
							
							this.checkedRightData = ids
							let arr = []
							res.data.forEach((item,index) => {
								if(ids.indexOf(item.value) != -1){
									arr.push(item)
								}
							})
							this.$emit('field-event', arr)
						} else {
						  this.$message.error(res.msg);
						}
					})
            },
			handleCheckRightAllChange(val) {
			  this.checkAllNodesRight(this.dataRight, val);
			},
			//全选
			checkAllNodesRight(nodes, checked) {
				if(checked){
					let arr = []
					 nodes.forEach(node => {
						arr.push(node.value)
					 });
					this.$refs.treeRight.setCheckedKeys(arr);
				}else{
					this.$refs.treeRight.setCheckedKeys([])
				}
			},
			handleNodeCheckChangeRight(node, checked) {
			  // 当某个节点的选中状态发生变化时，检查是否所有节点都被选中
			  const allNodes = this.getAllNodesRight(this.dataRight);
			  const allChecked = allNodes.every(n => this.$refs.treeRight.getCheckedKeys().includes(n.value));
			  
			  // 更新全选按钮的状态
			  this.checkedRight = allChecked;
			  this.$emit('field-event', this.$refs.treeRight.getCheckedNodes())
			},
			getAllNodesRight(nodes) {
			  let allNodes = [];
			  nodes.forEach(node => {
				allNodes.push(node);
			  });
			  return allNodes;
			},
        }
    }
</script>

<style scoped lang="scss">
    .tree-transfer{
        display: flex;
        .tree-transfer-left{
            max-width: 300px;
			flex: 1;
            border:1px #E5E5E5 solid;
            border-radius: 6px;
			overflow: hidden;
        }
        .tree-transfer-middle{
            display: flex;
			height:400px;
            justify-content: center;
            align-items: center;
            width: 80px;
        }
        .tree-transfer-right{
           max-width: 300px;
           flex: 1;
            border:1px #E5E5E5 solid;
            border-radius: 6px;
			overflow: hidden;
        }
		.title{
			height:36px;
			line-height: 36px;
			border-bottom:1px #E5E5E5 solid;
			box-sizing: border-box;
			padding: 0 10px;
			background-color: #eef5fe;
		}
		.opt{
			height:30px;
			line-height: 30px;
			border-bottom:1px #E5E5E5 solid;
			box-sizing: border-box;
			padding: 0 10px;
		}
		.kTree{
			height: 340px;
			margin: 10px 0;
			box-sizing: border-box;
			overflow:auto;
		}
    }
</style>